<main>
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>

  <div class="as-row as-gap-10 info">
    <div class="icon-wrapper">
      <mat-icon
        [svgIcon]="
          data.type === 'warn' ? 'ic-warning-alert' : 'ic-green-checkmark'
        "
      ></mat-icon>
    </div>
    <div class="as-column as-gap-10">
      <p class="as-font as-font-20 as-font-w-700 as-font-black-gray">
        {{ data.title }}
      </p>
      <p class="as-font as-font-16 as-font-normal as-font-black-gray">
        {{ data.subtitle }}
      </p>
    </div>
  </div>

  <div class="as-row as-align-center as-justify-sb as-buttons-container">
    <button
      mat-dialog-close
      class="as-font-green green"
      mat-stroked-button
      color="accent"
    >
      {{ data.cancelText }}
    </button>
    <button
      (click)="confirmAction()"
      class="as-color-white confirm"
      mat-flat-button
      [color]="data.type === 'warn' ? 'warn' : 'accent'"
    >
      {{ data.confirmText }}
    </button>
  </div>
</main>
